class CustomErrorStateMatcher {
    isErrorState(control, form) {
        const isSubmitted = form && form.submitted;
        return !!(control &&
            control.invalid &&
            (control.dirty || control.touched || isSubmitted));
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { CustomErrorStateMatcher };
